<span class="label">
  <span class="label-content">
    <span>{{ label() }}</span>
    <fb-scribe-suggestion-indicator
      [target]="markerTarget()"
      [fieldKey]="markerFieldKey()"
    ></fb-scribe-suggestion-indicator>
    <fb-amendment-field-indicator [rowIndex]="rowIndex()" [fieldKey]="markerFieldKey()" />
  </span>
</span>
<div class="box" [class.is-empty]="!text()">
  <span class="text">
    <span class="value">{{ text() }}</span>
    @if (showPlaceholder()) {
      <span class="placeholder">{{ placeholder() }}</span>
    }
  </span>
  <span class="chevron" aria-hidden="true">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 4L6 8L10 4" stroke="#8D9199" stroke-width="1.5" />
    </svg>
  </span>
</div>
